import React from "react";
import PropTypes from "prop-types";

export default function Lock(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 0C11.9729 0 5.85003 6.11757 5.85003 13.6374V21.8071H9.75005V13.6374C9.75005 8.24613 14.1239 3.85967 19.5001 3.85967C24.8763 3.85967 29.2502 8.24613 29.2502 13.6374V21.8713H33.1502V13.6374C33.15 6.11757 27.0264 0 19.5 0Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.95001 20.2632H37.05C38.1271 20.2632 39 21.1271 39 22.1929V47.924C39 48.7782 38.4319 49.5315 37.6044 49.774L20.0545 54.9202C19.8731 54.9736 19.6866 55 19.5 55C19.3134 55 19.1269 54.9736 18.9462 54.9202L1.39621 49.774C0.568124 49.5316 0 48.7782 0 47.924V22.193C0 21.1271 0.872919 20.2632 1.95001 20.2632ZM17.55 35.0585C17.55 33.9926 18.4229 33.1287 19.5 33.1287C20.5771 33.1287 21.45 33.9926 21.45 35.0585V40.2047C21.45 41.2706 20.5771 42.1345 19.5 42.1345C18.4229 42.1345 17.55 41.2706 17.55 40.2047V35.0585Z"
        fill={props.fill}
      />
    </svg>
  );
}

Lock.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
Lock.defaultProps = {
  className: "",
  fill: "#E9F1FE",
  width: 39,
  height: 55
};
